import React, { ReactElement } from 'react';
import { concernsColorsOrder, SortedTopConcern } from 'screens/WidgetGenerator/utils/answerClassificationBreakdown';
import { TopConcernsChartItem } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ClassificationTopConcernsHOC/TopConcernsChartItem';
import styles from './ClassificationTopConcernsHOC.module.scss';

interface Props {
  sortedTopConcern: SortedTopConcern[];
  displayTrend: boolean;
}

export const TopConcernsChart = (props: Props): ReactElement => {
  const { sortedTopConcern, displayTrend } = props;

  return (
    <div className={styles.topConcernsChart}>
      {sortedTopConcern.map((concern, index) => (
        <TopConcernsChartItem
          key={concern.label}
          concernItem={concern}
          color={concernsColorsOrder[index]}
          highestTotal={sortedTopConcern[0].total}
          displayTrend={displayTrend}
        />
      ))}
    </div>
  );
};
